import { isValidElement } from 'react';
import { isFunction, isObject } from 'lodash';

export default function isValidComponent(Component) {
    if (!isFunction(Component) && !isObject(Component)) return false;
    if (!isValidElement(Component) && !Component.displayName) return false;

    return true;
}
